import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { selectUserId, State as AccessTokenState } from '~/AccessToken';
import { ExchangeRates } from '~/Api/User/ExchangeRate';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { formatCondensedHumanDate } from '~/DateTime';
import {
	createExchangeRates,
	fetchExchangeRates,
	updateExchangeRates,
	updateGroupExchangeRates,
} from '~/ExchangeRate/actions';
import { selectRates, State as ExchangeRateState } from '~/ExchangeRate/reducer';

import SelectModal from './SelectModal';

interface State {
	accessToken: AccessTokenState;
	exchangeRate: ExchangeRateState;
}

interface Props {
	rates: ExchangeRates[] | null;
	customRates: ExchangeRates[] | null;
	initiallySelectedRates: ExchangeRates | null;
	isFetching: boolean;
	isUpdating: boolean;
	formatDate(date: Date): string;
}

const filterRates = memoizeOne(
	(
		rates: ExchangeRates[] | null,
		group: UserProductGroup
	): {
		rates: ExchangeRates[] | null;
		customRates: ExchangeRates[] | null;
		initiallySelectedDate: Date | null;
		initiallySelectedRates: ExchangeRates | null;
	} => {
		const ratesSettings = group.exchangeRates.settings;
		const selectedRates = rates
			? rates.find((rates) => {
					return (
						rates.type === ratesSettings.type &&
						(!rates.isCustom() || rates.id === ratesSettings.customExchangeRates?.id)
					);
			  })
			: null;

		return {
			rates: rates ? rates.filter((rate) => !rate.isCustom()) : null,
			customRates: rates ? rates.filter((rate) => rate.isCustom()) : null,
			initiallySelectedDate: ratesSettings.date,
			initiallySelectedRates: selectedRates || null,
		};
	}
);

function mapStateToProps(state: State, props: { group: UserProductGroup }): Props {
	const userId = selectUserId(state.accessToken);

	return {
		...filterRates(userId ? selectRates(state.exchangeRate, userId, props.group.id) : null, props.group),
		isFetching: Boolean(state.exchangeRate.allRates && state.exchangeRate.allRates.isFetching),
		isUpdating:
			state.exchangeRate.createRequest !== null ||
			state.exchangeRate.updateRequest !== null ||
			state.exchangeRate.updateGroupRatesRequest !== null,
		formatDate: formatCondensedHumanDate,
	};
}

const actions = {
	onLoad: fetchExchangeRates,
	onSelect: updateGroupExchangeRates,
	onCreate: createExchangeRates,
	onUpdate: updateExchangeRates,
};

export default connect(mapStateToProps, actions)(SelectModal);
